import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import resolveUserSteamId from "./resolveUserSteamId";

export default function RebuildPlayerEloDialog({
  openState,
  userContext,
  onClose,
  onConfirm,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (openState) {
      setSubmitting(false);
      setError("");
    }
  }, [openState, userContext?.row?.userId]);

  if (!userContext?.row) {
    return <></>;
  }

  const { row } = userContext;
  const nickname = row.nickname || "this player";
  const steamId = resolveUserSteamId(row);
  const canSubmit = Boolean(steamId) && !submitting;

  const handleConfirm = async () => {
    setSubmitting(true);
    setError("");

    try {
      const result = await onConfirm({
        userId: row.userId,
        steamId,
      });

      if (result?.ok) {
        onClose();
        return;
      }

      setError(result?.error || "Rebuild failed");
      setSubmitting(false);
    } catch (err) {
      setError(err?.message || "Rebuild failed");
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={openState}
      onClose={submitting ? undefined : onClose}
      aria-labelledby="rebuild-player-elo-dialog-title"
    >
      <DialogTitle id="rebuild-player-elo-dialog-title">
        Rebuild {nickname}&apos;s ELO?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          This runs a real ELO rebuild from completed match history on the server. Only this
          player&apos;s ratings are recomputed; other users are not affected.
        </DialogContentText>

        <Typography variant="body2" style={{ marginTop: 16 }}>
          <strong>Player:</strong> {row.nickname || row.name || "—"}
        </Typography>
        <Typography variant="body2">
          <strong>Steam ID:</strong> {steamId || "—"}
        </Typography>

        {error && (
          <Typography variant="body2" style={{ marginTop: 12, color: "#d32f2f" }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          disabled={!canSubmit}
        >
          {submitting ? "Rebuilding..." : "Rebuild ELO"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
